var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoMini(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 24,
    viewBox: "0 0 29 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.5597 24C24.9414 24 24.3754 23.8478 23.8617 23.5434C23.3576 23.2485 22.9534 22.8489 22.6489 22.3448C22.3541 21.8312 22.2065 21.2651 22.2065 20.6469C22.2065 20.0286 22.3541 19.4673 22.6489 18.9631C22.9534 18.4495 23.3576 18.0452 23.8617 17.7503C24.3754 17.4459 24.9414 17.2937 25.5597 17.2937C26.1781 17.2937 26.7393 17.4459 27.2434 17.7503C27.7571 18.0452 28.1615 18.4495 28.4562 18.9631C28.7607 19.4673 28.9128 20.0286 28.9128 20.6469C28.9128 21.2651 28.7607 21.8312 28.4562 22.3448C28.1615 22.8489 27.7571 23.2485 27.2434 23.5434C26.7393 23.8478 26.1781 24 25.5597 24Z",
    fill: "#FFD966"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 23.5434V0H5.49346V9.47444L13.4411 0H20.1474L10.5731 11.201L21.6314 23.5434H14.0547L5.49346 13.8549V23.5434H0Z",
    fill: "#FFD966"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoMini);
export default __webpack_public_path__ + "static/media/logo_mini.177b20c26d110458d4899cea82b17750.svg";
export { ForwardRef as ReactComponent };